import { Component, inject, Input, Renderer2 } from '@angular/core';

@Component({
    selector: 'fourd-navbar-toggler',
    imports: [],
    templateUrl: './navbar-toggler.component.html',
    styleUrl: './navbar-toggler.component.css',
    host: {
        'class': 'navbar-toggler',
        '[class.collapsed]': 'isCollapsed',
        '[attr.aria-controls]': 'toggleTargetElementId',
        '[attr.aria-expanded]': '!isCollapsed',
        '[attr.aria-label]': '"Toggle navigation"',
        '[attr.type]': '"button"',
        '(click)': 'toggle()',
    }
})
export class NavbarTogglerComponent {

  protected renderer = inject(Renderer2);

  @Input() toggleTargetElementId: string = 'navbarCollapse';
  @Input() toggleTargetShowClass: string = 'show';
  isCollapsed: boolean = true; // Start collapsed

  toggle(): void {
    this.isCollapsed = !this.isCollapsed;
    if (this.toggleTargetElementId) {
      let toggleTargetElement = document?.getElementById(this.toggleTargetElementId);
      if (toggleTargetElement) {
        if (this.isCollapsed) {
          this.renderer?.removeClass(toggleTargetElement, this.toggleTargetShowClass);
        }
        else {
          this.renderer?.addClass(toggleTargetElement, this.toggleTargetShowClass);
        }
      }
    }
  }
}
